import { useEffect, useState } from "react";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches === true ||
  window.navigator.standalone === true;

const isPhoneDevice = () => {
  const { userAgent = "", userAgentData } = window.navigator;

  if (typeof userAgentData?.mobile === "boolean") {
    return userAgentData.mobile;
  }

  return /iPhone|iPod|Windows Phone/i.test(userAgent) || (/Android/i.test(userAgent) && /Mobile/i.test(userAgent));
};

const isIosSafari = () => {
  const userAgent = window.navigator.userAgent;
  const isIos = /iPad|iPhone|iPod/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/CriOS|FxiOS|EdgiOS/.test(userAgent);

  return isIos && isSafari;
};

const getInstallInstructions = (showIosMessage) =>
  showIosMessage
    ? "To install on iPhone: tap Share, then tap Add to Home Screen."
    : "To install: open your browser menu and choose Install app or Add to Home Screen.";

const InstallBanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIosMessage, setShowIosMessage] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (isStandalone() || !isPhoneDevice()) {
      return undefined;
    }

    setShowIosMessage(isIosSafari());

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    const handleAppInstalled = () => {
      setDeferredPrompt(null);
      setShowIosMessage(false);
      setIsVisible(false);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) {
      window.alert(getInstallInstructions(showIosMessage));
      return;
    }

    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setIsVisible(false);
  };

  if (!isVisible || isStandalone() || !isPhoneDevice()) {
    return null;
  }

  const bannerText = deferredPrompt
    ? "Add this app to your home screen for faster access."
    : showIosMessage
      ? "On iPhone, tap Share, then Add to Home Screen."
      : "Open your browser menu and choose Install app or Add to Home Screen.";
  const primaryActionLabel = deferredPrompt ? "Install" : "Show steps";

  return (
    <div className="install-banner" role="status" aria-live="polite">
      <div className="install-banner__content">
        <strong className="install-banner__title">Install Limitless FX</strong>
        <span className="install-banner__text">{bannerText}</span>
      </div>
      <div className="install-banner__actions">
        <button className="install-banner__button install-banner__button--primary" onClick={handleInstall}>
          {primaryActionLabel}
        </button>
        <button className="install-banner__button install-banner__button--secondary" onClick={handleDismiss}>
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default InstallBanner;
